<template>
    <div v-if="!file.for_destroy" class="file-component">
        <div :class="['file-preview', {'invalid': invalid}]">
            <input
                v-model="file_ext"
                v-validate.initial="{file_ext: available_file_extensions}"
                type="hidden"
                :name="`${name}[file_ext]`"
                :data-vv-scope="scope">

            <div class="preview-file">
                <img v-if="isImage" :src="file_url" :alt="file_ext">
                <span v-if="file_ext == 'pdf'" class="icon icon-file-pdf" />
                <span v-if="isDoc" class="icon icon-file-word" />
                <span v-if="isOtherFile" class="icon icon-file-empty" />
            </div>
            <div class="name-file">
                {{ file.name }}
            </div>
            <div v-if="!file.for_attach" class="nav-btn download-file">
                <a :href="file.url" :download="file.name">
                    <span class="icon icon-download" />
                </a>
            </div>
            <div v-if="$listeners.remove" class="nav-btn remove-file" @click="$emit('remove')">
                <span class="icon icon-cross" />
            </div>
            <div v-if="$listeners.change" class="nav-btn edit-file" @click.prevent="$emit('change')">
                <span class="icon icon-loop" />
            </div>
        </div>
        <div v-if="invalid">
            <span class="error-message">{{ errors.first(errorFieldName) }}</span>
        </div>
    </div>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: ['file', 'name', 'scope'],
    data() {
      return {
        available_file_types: ['image/jpeg', 'image/png', 'application/msword', 'application/pdf',
                   'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        available_file_extensions: ['jpeg', 'jpg', 'png', 'doc', 'docx', 'pdf']
      }
    },
    computed: {
      isImage: function() {
        return ['jpeg', 'jpg', 'png'].includes(this.file_ext)
      },
      isDoc: function() {
        return ['doc', 'docx'].includes(this.file_ext)
      },
      isOtherFile: function() {
        return !this.available_file_extensions.includes(this.file_ext)
      },
      invalid: function() {
        return this.errors.first(this.errorFieldName)
      },
      file_type: function() {
        return this.file.type
      },
      file_url: function() {
        return this.file.url
      },
      file_ext: function(){
        return this.file.name.split('.').pop()
      },
      errorFieldName: function() {
        return this.scope ? `${this.scope}.${this.name}[file_ext]` : `${this.name}[file_ext]`
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@stylesheets/_vars.scss';

  $border_color: $light_gray_a;

  .file-component{
    margin-bottom: 10px;
    .file-preview{
      height: 48px;
      display: flex;
      align-items: stretch;
      border: 1px solid $border_color;
      div{
        height: 100%;
      }
      &.invalid {
        border: 1px solid $red
      }
    }
    .preview-file{
      width: 50px;
      margin-right: 5px;
      text-align: center;
      line-height: 70px;
      border-right: 1px solid $border_color;
      img {
        max-height: 100%;
        max-width: 100%;
        margin: auto;
      }
      .icon{
        font-size: 35px;
        color: $orange_a;
      }
    }

    .name-file{
      padding: 10px 0;
      flex: 1;
      line-height: 30px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .nav-btn {
      width: 50px;
      text-align: center;
      text-decoration: none;
      border-left: 1px solid $border_color;
      background-color: $light_gray_c;
      cursor: pointer;
      &:hover{
        background-color: $light_gray_a;
      }
      a {
        text-decoration: none;
        &:hover{
          text-decoration: none;
        }
      }
      .icon{
        color: $gray_b;
        float: inherit;
        display: inline;
        font-size: 18px;
      }
    }

    .download-file{
      line-height: 57px;
      .icon{ font-size: 20px; }
    }
    .remove-file{
      line-height: 57px;
      .icon { color: #ff0049; }
    }
    .edit-file{
      line-height: 58px;
      .icon { font-weight: bold; }
    }
  }
</style>

